export default __webpack_public_path__ + "static/media/addon8.15201540.webp";